module.exports = __webpack_public_path__ + "static/media/rx2ulogo.3955693c.png";